module.exports = __webpack_public_path__ + "static/media/close-light.2700b55e.svg";